import { render, staticRenderFns } from "./Chats.vue?vue&type=template&id=75fb8a03&scoped=true"
import script from "./Chats.vue?vue&type=script&lang=js"
export * from "./Chats.vue?vue&type=script&lang=js"
import style1 from "./Chats.vue?vue&type=style&index=1&id=75fb8a03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fb8a03",
  null
  
)

export default component.exports